import { loadStripe } from '@stripe/stripe-js';
import axios from '../../axios';
import { SERVICE_LISTING_API } from '../api';
import { getActiveProvider } from './tenantApi';

let cachedKey = '';
let cachedStripePromise = null;
let cachedProvider = '';
let cachedIntegrationPromise = null;

const getPublishableKey = (response) => {
  const payload = response?.data?.data ?? response?.data ?? {};
  const candidates = [
    payload,
    ...(Array.isArray(payload) ? payload : []),
    ...(Array.isArray(payload?.services) ? payload.services : []),
    ...(Array.isArray(payload?.custom_services) ? payload.custom_services : []),
  ];
  return candidates.find((item) => (
    typeof item?.stripe_publishable_key === 'string'
    && item.stripe_publishable_key.startsWith('pk_')
  ))?.stripe_publishable_key || '';
};

export const clearTenantStripeCache = () => {
  cachedKey = '';
  cachedStripePromise = null;
  cachedProvider = '';
  cachedIntegrationPromise = null;
};

export const getTenantStripePromise = () => {
  const provider = getActiveProvider();

  if (cachedIntegrationPromise && cachedProvider === provider) {
    return cachedIntegrationPromise;
  }

  cachedProvider = provider;
  const integrationPromise = (async () => {
    try {
      const response = await axios.get(SERVICE_LISTING_API);
      const publishableKey = getPublishableKey(response);

      if (!publishableKey) return null;

      if (!cachedStripePromise || cachedKey !== publishableKey) {
        cachedKey = publishableKey;
        cachedStripePromise = loadStripe(publishableKey);
      }

      return cachedStripePromise;
    } catch (error) {
      if (cachedIntegrationPromise === integrationPromise) {
        cachedIntegrationPromise = null;
      }
      return null;
    }
  })();
  cachedIntegrationPromise = integrationPromise;

  return cachedIntegrationPromise;
};
